<template>
    <div class="card card-form">
        <!-- Toolbar -->
        <div class="card-header">
            <responsive>
                <div class="d-flex flex-nowrap">
                    <div class="btn-toolbar ml-auto">
                        <button class="btn btn-primary px-2 mr-1 d-lg-none" @click="filter.visible = !filter.visible">
                            <i class="fas fa-fw fa-filter" v-if="!filter.visible"></i>
                            <i class="fas fa-fw fa-times" v-if="filter.visible"></i>
                        </button>
                        <button class="btn btn-primary" @click="filterData()">
                            {{ $t('[[[Filtruj]]]') }}
                        </button>
                        <button class="btn btn-secondary" @click="resetFilter()">
                            {{ $t('[[[Resetuj]]]') }}
                        </button>
                    </div>
                </div>
            </responsive>
        </div>
        <div class="row no-gutters">
            <!-- Filtry -->
            <div class="col-lg-3 order-lg-last p-3 bg-light" :class="{'d-none d-lg-block': !filter.visible}">
                <b-form-group :label="$t('[[[Nazwa użytkownika]]]')" :invalid-feedback="filter.$errors.first('userName')" :state="filter.$errors.state('userName')">
                    <b-form-input v-model="filter.userName" type="text" name="userName"></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('[[[Data od]]]')" :invalid-feedback="filter.$errors.first('dateFromUtc')" :state="filter.$errors.state('dateFromUtc')">
                    <datetimepicker v-model="filter.dateFromUtc" type="datetime" />
                </b-form-group>
                <b-form-group :label="$t('[[[Data do]]]')" :invalid-feedback="filter.$errors.first('dateDueUtc')" :state="filter.$errors.state('dateDueUtc')">
                    <datetimepicker v-model="filter.dateDueUtc" type="datetime" />
                </b-form-group>
                <b-form-group :label="$t('[[[Zdarzenie]]]')" :invalid-feedback="filter.$errors.first('eventType')" :state="filter.$errors.state('eventType')">
                    <b-form-select name="eventType" v-model="filter.eventType" :options="eventTypeOptions">
                        <template slot="first">
                            <option :value="null"></option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </div>
            <!-- Tabela -->
            <div class="col-lg-9 p-3">
                <responsive>
                    <table class="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th><sort :pager="pager" @change="onSorting" header="Id">{{ $t('[[[Autor zmian]]]') }}</sort></th>
                                <th><sort :pager="pager" @change="onSorting" header="EventTypeId">{{ $t('[[[Typ zdarzenia]]]') }}</sort></th>
                                <th><sort :pager="pager" @change="onSorting" header="EventDate">{{ $t('[[[Data zdarzenia]]]') }}</sort></th>
                                <th>{{ $t('[[[Id sesji]]]') }}</th>
                                <th>{{ $t('[[[Ip address]]]') }}</th>
                            </tr>
                        </thead>
                        <tr v-for="item in items" :key="item.id">
                            <td>
                                <div class="mb-1">
                                    <b-link :to="{name:'core-users-edit', params: { id: author(item).id }}" :disabled="!item.author">
                                        {{ author(item).userName || 'n/a' }}
                                    </b-link>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <b>{{ eventTypeTranslator.translate(item.eventType) }}</b>
                                </div>
                            </td>
                            <td>
                                {{ item.eventDate | datetime }}
                            </td>
                            <td>
                                {{ item.sessionId }}
                            </td>
                            <td>
                                {{ item.ipAddress }}
                            </td>
                        </tr>
                    </table>
                </responsive>
            </div>
        </div>
        <div class="card-footer">
            <responsive>
                <div class="d-flex flex-nowrap mt-auto">
                    <pagination :pager="pager" @change="filterData()" class="mx-auto"></pagination>
                    <select v-model="pager.pageSize" @change="filterData()" class="form-control w-auto ml-3">
                        <option v-for="item in [10, 20, 50, 100]" :key="item" :value="item">{{item}}</option>
                    </select>
                </div>
            </responsive>
        </div>
    </div>
</template>

<script lang="js">
import AuthLogsService from '@/services/core/AuthLogsService';
import { EventTypeOptions, EventTypeTranslator } from '@/enums/AuthEnums';

export default
{
    data: function()
    {
        return {
            mobile: false,
            phone: false,
            items: []
        };
    },

    store: {
        filter: 'modules.core.authlogs.filter',
        pager: 'modules.core.authlogs.pager'
    },

    computed:
    {
        eventTypeOptions()
        {
            return EventTypeOptions;
        },
        eventTypeTranslator()
        {
            return EventTypeTranslator;
        }
    },

    created: function()
    {
        this.initForm();
        this.loadData();
    },

    methods:
    {
        async initForm()
        {
        },

        async loadData()
        {
            this.items = [];

            try
            {
                let response = await AuthLogsService.getAuthLog(this.filter, this.pager);
                this.pager.setTotalRows(response.totalRows);
                this.items = response.data.items;
            }
            catch (ex)
            {
                if (ex.code === 400)
                    this.$alert.warning(ex.message);

                if (ex.code === 422)
                    this.filter.$errors.record(ex.data.errors);

                this.pager.setTotalRows(0);
                this.items = [];
                this.$log.debug(ex);
            }
        },

        async filterData()
        {
            await this.loadData();
        },

        async resetFilter()
        {
            this.filter.reset();
            await this.loadData();
        },

        async onSorting(sorting, order)
        {
            await this.loadData();
        },

        author(item)
        {
            return item.author || {};
        }
    }
};
</script>
